import createReactClass from "create-react-class";
import moment from "moment";
import React from "react";
import { Button, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { ErrorAction } from "../actions/errorActions";
import { FormRequestActions } from "../actions/formRequestActions";
import { PollActions } from "../actions/pollActions";
import { ConfirmationModalActions } from "../actions/submissionConfirmationModalActions";
import Constants from "../constants/constants";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { userStore } from "../stores/user";
import { storeUtils } from "../stores/util";
import { formConversion } from "../util/formConversion";

var TYPES = Constants.RestrictionTypes;
var disableSubmit = true;
var changesMadeToRequestQuest = false;

export const SubmissionConfirmationModal = createReactClass({
  getInitialState() {
    return {
      showModal: false,
      superName: "",
      commentsDisable: false,
      checkComments: false,
      commentsCheckclass: "",
      sloDtComment: "",
      formCDTComment: "",
    };
  },

  close() {
    //call action creator to store the comment here...
    //reset checkbox and radiobutton field
    ConfirmationModalActions.confirmationChanged(null);
    this.setState({ showModal: false, superName: "", radioChanged: true });
  },

  cancel() {
    //reset checkbox and radiobutton field
    ConfirmationModalActions.confirmationChanged(null);
    this.setState({ showModal: false, superName: "", radioChanged: true });
  },

  open() {
    FormRequestActions.calculateTracks(this.props.form);
    let overlapCheck = false; //Disabling the overlap check for now
    var proprs = this.props;
    var selfState = this;
    //validate MP before submitting
    if (
      overlapCheck &&
      this.props.form.type === "A" &&
      !(
        userStore.getSelectedRole().indexOf(Constants.Roles.FIELD_USER) === 0 &&
        proprs.form.status === "restriction"
      )
    ) {
      PollActions.blockScreen();
      $.ajax({
        type: "POST",
        contentType: "application/converters; charset=utf-8",
        url: storeUtils.URL_ROOT + "form/validateMPRange",
        dataType: "json",
        data: JSON.stringify(formConversion.getServerFormat(this.props.form)),
        success: function (data, status, xhr) {
          PollActions.unblockScreen();
          console.log("successful transport to server", data, status, xhr);
          var msgRes = [];
          var msgReq = [];
          if (data.success && data.data.length > 0) {
            data.data.map(function (g) {
              if (g.status === "request") {
                msgReq.push(" GR-" + g.syncId);
              } else {
                msgRes.push(g.restrictionDetail.controlNumber);
              }
            });
            var dispMessage = "";
            if (msgRes.length > 0) {
              if (msgRes.length === 1) {
                dispMessage = " restriction " + msgRes;
              } else {
                dispMessage = " restrictions " + msgRes;
              }
            }
            if (msgReq.length > 0) {
              if (msgReq.length === 1) {
                dispMessage =
                  dispMessage +
                  (dispMessage.length > 0 ? " and " : "") +
                  " request " +
                  msgReq;
              } else {
                dispMessage =
                  dispMessage +
                  (dispMessage.length > 0 ? " and " : "") +
                  " requests " +
                  msgReq;
              }
            }

            window
              .confirm("Duplicate Milepost Warning", {
                description:
                  "Selected MP range is already present on" +
                  dispMessage +
                  " Do you want to continue?",
                confirmLabel: "Proceed",
                abortLabel: "Go Back",
              })
              .then(
                function () {
                  //only open the modal if the form validates
                  var canSubmit = restrictionRequestStore.formValid();
                  if (!canSubmit) {
                    //event.stopPropagation();
                    //window.alert('Request submission failed.\nErrors were found on this request. Please fix all errors and submit again.')
                    ErrorAction.showModalError(
                      "Request submission failed. Errors were found on this request. Please fix all errors and submit again."
                    );
                  } else {
                    var user = userStore.getSelectedRole();
                    if (
                      proprs.form.comments.length === 0 ||
                      proprs.form.id === "" ||
                      user.indexOf(Constants.Roles.FIELD_USER) === 0
                    ) {
                      selfState.setState({
                        showModal: true,
                        superName: "",
                        commentsDisable: false,
                        checkComments: false,
                        commentsCheckclass: "hidden",
                        userRole: user,
                      });
                    } else {
                      if (
                        user.indexOf(Constants.Roles.FIELD_USER) !== 0 &&
                        this.props.form.isCommentOpened
                      ) {
                        selfState.setState({
                          showModal: true,
                          superName: "",
                          commentsDisable: true,
                          checkComments: true,
                          commentsCheckclass: "",
                          userRole: user,
                        });
                      } else {
                        selfState.setState({
                          showModal: true,
                          superName: "",
                          commentsDisable: false,
                          checkComments: false,
                          commentsCheckclass: "",
                          userRole: user,
                        });
                      }
                    }
                  }
                  ConfirmationModalActions.validateBeforeSubmitting();
                }.bind(this)
              );
          } else {
            //only open the modal if the form validates
            var canSubmit = restrictionRequestStore.formValid();
            if (!canSubmit) {
              //event.stopPropagation();
              //window.alert('Request submission failed.\nErrors were found on this request. Please fix all errors and submit again.')
              ErrorAction.showModalError(
                "Request submission failed. Errors were found on this request. Please fix all errors and submit again."
              );
            } else {
              var user = userStore.getSelectedRole();
              if (
                proprs.form.comments.length === 0 ||
                proprs.form.id === "" ||
                user.indexOf(Constants.Roles.FIELD_USER) === 0
              ) {
                selfState.setState({
                  showModal: true,
                  superName: "",
                  commentsDisable: false,
                  checkComments: false,
                  commentsCheckclass: "hidden",
                  userRole: user,
                });
              } else {
                if (
                  user.indexOf(Constants.Roles.FIELD_USER) !== 0 &&
                  this.props.form.isCommentOpened
                ) {
                  selfState.setState({
                    showModal: true,
                    superName: "",
                    commentsDisable: true,
                    checkComments: true,
                    commentsCheckclass: "",
                    userRole: user,
                  });
                } else {
                  selfState.setState({
                    showModal: true,
                    superName: "",
                    commentsDisable: false,
                    checkComments: false,
                    commentsCheckclass: "",
                    userRole: user,
                  });
                }
              }
            }
            ConfirmationModalActions.validateBeforeSubmitting();
          }
        }.bind(this),
        error: function (data, status, error) {
          PollActions.unblockScreen();
          console.log("error" + error);
        },
      });
    } else {
      //only open the modal if the form validates
      var canSubmit = restrictionRequestStore.formValid();
      if (!canSubmit) {
        //event.stopPropagation();
        //window.alert('Request submission failed.\nErrors were found on this request. Please fix all errors and submit again.')
        ErrorAction.showModalError(
          "Request submission failed. Errors were found on this request. Please fix all errors and submit again."
        );
      } else {
        var user = userStore.getSelectedRole();
        if (
          proprs.form.comments.length === 0 ||
          proprs.form.id === "" ||
          user.indexOf(Constants.Roles.FIELD_USER) === 0
        ) {
          selfState.setState({
            showModal: true,
            superName: "",
            commentsDisable: false,
            checkComments: false,
            commentsCheckclass: "hidden",
            userRole: user,
          });
        } else {
          if (
            user.indexOf(Constants.Roles.FIELD_USER) !== 0 &&
            this.props.form.isCommentOpened
          ) {
            selfState.setState({
              showModal: true,
              superName: "",
              commentsDisable: true,
              checkComments: true,
              commentsCheckclass: "",
              userRole: user,
            });
          } else {
            selfState.setState({
              showModal: true,
              superName: "",
              commentsDisable: false,
              checkComments: false,
              commentsCheckclass: "",
              userRole: user,
            });
          }
        }
      }
      ConfirmationModalActions.validateBeforeSubmitting();
    }
  },

  submit() {
    if (
      this.props.compactionFlag &&
      this.props.form.reasonDescription &&
      this.props.form.reasonDescription.startsWith("COMPACTION")
    ) {
      //Show the further confirmation modal for request submission
      window
        .confirm("Compaction Slow Order Tonnage Tracker", {
          description:
            "Compaction speed restrictions will be tracked for tonnage, once 100k tons are exceeded, speed restriction will be sent to NOC for removal. Are you sure you want to proceed?",
          confirmLabel: "Proceed",
          abortLabel: "Go Back",
        })
        .then(
          function () {
            this.setState({ showModal: false, superName: "" });
            this.props.submitAction();
          }.bind(this)
        );
    } else {
      this.setState({ showModal: false, superName: "" });
      this.props.submitAction();
    }
  },

  superOnChange(e) {
    var st = this.state;
    st.superName = e.target.value.toUpperCase();
    this.setState(st);
  },

  SuperOnBlur(e) {
    var trimmedName = e.target.value.trim().toUpperCase();
    var st = this.state;
    st.superName = trimmedName;
    this.setState(st);
    ConfirmationModalActions.superAuthChanged(trimmedName);
  },

  commentsOnChange: function () {
    var st = this.state;
    st.commentsDisable = true;
    st.checkComments = true;
    this.setState(st);
  },

  radioOnChange: function (e) {
    console.log("radio changed", e);
    ConfirmationModalActions.radioChanged(e.target.id, e.target.value);
    if (this.props.buttonText === "Update Request") {
      if (this.props.form.type === "A") {
        changesMadeToRequestQuest = true;
      }
      disableSubmit = false;
    }
  },

  confirmChanged: function (e) {
    ConfirmationModalActions.confirmationChanged(e.target.checked);
  },

  sloDtOnBlur(e) {
    ConfirmationModalActions.sloDtChanged(e.target.value);
  },

  formCDtOnBlur(e) {
    ConfirmationModalActions.formCDtChanged(e.target.value);
  },

  formTCMDtOnBlur(e) {
    ConfirmationModalActions.formTCMDtChanged(e.target.value);
  },

  onChangeToUpper: function (e) {
    if (e.target.value || e.target.value === "") {
      let st = this.state;

      if (e.target.id === "sloDtComment") {
        st.sloDtComment = e.target.value.toUpperCase();
      } else if (e.target.id === "formCDTComment") {
        st.formCDTComment = e.target.value.toUpperCase();
      } else {
        st.formTCMDTChangeComment = e.target.value.toUpperCase();
      }

      this.setState(st);
    }
  },

  render: function () {
    var buttonText = this.props.buttonText;
    var component;
    var form = this.props.form;
    var reasonList = restrictionRequestStore.getReasonCodes();
    var userRoles = userStore.getSelectedRole();
    let reason = [];
    let modalTitle = (
      <Modal.Title>
        Confirm:{" "}
        {this.props.question.charAt(0).toUpperCase() +
          this.props.question.slice(1)}{" "}
        on subdivision {form.subdivision}?
      </Modal.Title>
    );

    if (reasonList && reasonList.length > 1) {
      reason = reasonList.filter(function (e) {
        if (e.value === form.reason) {
          return true;
        }
      });
      if (!reason || reason.length < 1) {
        reason = { text: "" };
      } else {
        reason = reason[0];
      }
    }

    var flags = form.borderingFlags.map(function (bFlag) {
      if (
        bFlag &&
        bFlag.mp &&
        String(bFlag.mp).split(".").length == 2 &&
        String(bFlag.mp).split(".")[1].trim().length == 0
      ) {
        return (
          <div>
            {bFlag.subdivision +
              ": " +
              bFlag.mp +
              "0" +
              (bFlag.mpSuffix ? bFlag.mpSuffix : "")}
          </div>
        );
      } else if (bFlag && bFlag.mp && String(bFlag.mp).indexOf(".") == -1) {
        return (
          <div>
            {bFlag.subdivision +
              ": " +
              bFlag.mp +
              ".0" +
              (bFlag.mpSuffix ? bFlag.mpSuffix : "")}
          </div>
        );
      } else {
        return (
          <div>
            {bFlag.subdivision +
              ": " +
              bFlag.mp +
              (bFlag.mpSuffix ? bFlag.mpSuffix : "")}
          </div>
        );
      }
    });

    var comments = form.comments.map(function (com, i) {
      return <div key={i}> {com.comment.toUpperCase()} </div>;
    });

    const { keyTrainSpd, keyTrainComment } = window.gritConfig;
    if (Number(form.freightSpeed) === Number(keyTrainSpd)) {
      comments?.unshift(<div key="key-train">{keyTrainComment}</div>);
    }

    var workStartDateTime = "",
      startDateTime;
    if (form.type === TYPES.A) {
      if (form.effectiveDate != null && form.effectiveDate !== "") {
        startDateTime = moment(
          form.effectiveDate + " " + form.effectiveTime,
          "MMDDYY HHmm"
        );
        workStartDateTime =
          startDateTime.format("ddd HH:mm") +
          "{tz} ".replace("{tz}", form.timezone) +
          startDateTime.format("MM/DD/YY");
      }
      var workEndDateTime = moment(form.expectedExpireDate, "MMDDYYYY");

      //only show sloDt if field user looking at a restriction
      var confirmTagsPlaced = "",
        createInTss = "",
        sloDt,
        commentReview = "";
      commentReview = (
        <div className={this.state.commentsCheckclass}>
          <span>I have reviewed the comments </span>
          <input
            type="checkbox"
            className={this.state.commentsCheckclass}
            disabled={this.state.commentsDisable}
            checked={this.state.checkComments}
            id="commentsRead"
            name="commentsRead"
            value="active"
            onChange={this.commentsOnChange}
          />
        </div>
      );

      if (
        form.status === Constants.RestrictionStatuses.REQUESTED &&
        form.controlNumber > 0
      ) {
        disableSubmit =
          typeof form.tmdsTagsPlaced !== "boolean" ||
          form.tmdsTagsPlaced === false;

        confirmTagsPlaced = (
          <div>
            Confirm that TMDS Track Tags have been placed or modified as needed:
            <input
              id="tmdsModifyTagsPlaced"
              type="checkbox"
              name="tmdsModifyTagsPlaced"
              checked={form.tmdsTagsPlaced}
              onChange={this.confirmChanged}
            />
          </div>
        );

        component = (
          <div>
            <div>
              Subdivision: <span className="bold">{form.subdivision}</span>
            </div>
            <div>
              From MP:{" "}
              <span className="bold">
                {form.workStartMp} {form.workStartMpSuffix}
              </span>
            </div>
            <div>
              To MP:{" "}
              <span className="bold">
                {form.workEndMp} {form.workEndMpSuffix}
              </span>
            </div>

            <div>
              Passenger speed:{" "}
              <span className="bold">{form.passengerSpeed}</span>
            </div>
            <div>
              Freight speed: <span className="bold">{form.freightSpeed}</span>
            </div>

            <div>
              Estimated Removal Date:{" "}
              <span className="bold">
                {workEndDateTime.format("ddd MM/DD/YY")}
              </span>
            </div>

            <div>
              Short Flag:{" "}
              <span className="bold">
                {form.shortFlagOneMp} {form.shortFlagOneMpSuffix}
              </span>
            </div>
            <div>
              Short Flag:{" "}
              <span className="bold">
                {form.shortFlagTwoMp} {form.shortFlagTwoMpSuffix}
              </span>
            </div>
            <div>
              No Flags:{" "}
              <span className="bold">
                {form.shortFlagsNotDisplayed ? "Y" : ""}
              </span>
            </div>
            <div>
              Effective DateTime:{" "}
              <span className="bold">{workStartDateTime}</span>
            </div>

            <div>
              Reason: <span className="bold">{form.reasonDescription}</span>
            </div>
            <div>
              Phone Number: <span className="bold">{form.phoneNumber}</span>
            </div>

            <div>
              Requested by: <span className="bold">{form.authorizedBy}</span>
            </div>
            <div>
              Tracks:{" "}
              <span className="bold">
                {form.tracks
                  .map(function (track) {
                    return track.name;
                  })
                  .join(", ")}
              </span>
            </div>

            <div>
              Comments:
              <span className="bold">{comments}</span>
            </div>
            <div>
              Bordering Flags: <span className="bold">{flags}</span>
            </div>
            <hr />
            {/*{commentReview}*/}
            <br />
            {confirmTagsPlaced}
            {createInTss}
          </div>
        );
      } else if (form.status === Constants.RestrictionStatuses.REQUESTED) {
        if (userRoles.indexOf(Constants.Roles.FIELD_USER) > -1) {
          //if either is set to the default value, disableSubmit
          if (
            this.state.checkComments ||
            this.props.form.comments.length === 0 ||
            this.props.form.id === "" ||
            userRoles.indexOf(Constants.Roles.FIELD_USER) === 0
          ) {
            disableSubmit = false;
          }
          
          if (buttonText === "Update Request") {
            if (
              this.state.checkComments ||
              this.props.form.comments.length === 0 ||
              this.props.form.id === "" ||
              userRoles.indexOf(Constants.Roles.FIELD_USER) === 0
            ) {
              disableSubmit = !this.props.modified;
              if (this.props.form.type === "A") {
                if (
                  changesMadeToRequestQuest === true ||
                  this.props.modified === true
                ) {
                  disableSubmit = false;
                  changesMadeToRequestQuest = false;
                } else {
                  disableSubmit = true;
                }
              }
            } else {
              disableSubmit = true;
            }
          }
        } else if (userRoles.indexOf(Constants.Roles.DISPATCHER) > -1) {
          //dispatcher looking at a request or direct issuing

          if (restrictionRequestStore.isModifying()) {
            //if either is not a boolean (ie set to a value), disable submit
            if (
              this.state.checkComments ||
              this.props.form.comments.length === 0 ||
              this.props.form.id === "" ||
              userRoles.indexOf(Constants.Roles.FIELD_USER) === 0
            ) {
              disableSubmit =
                typeof form.tmdsTagsPlaced !== "boolean" ||
                form.tmdsTagsPlaced === false;
            } else {
              disableSubmit = true;
            }

            form.sendToTss = true;
            
            confirmTagsPlaced = (
              <div>
                Confirm that you have placed TMDS Track Tags if required:
                <input
                  id="tmdsTagsPlaced"
                  type="checkbox"
                  name="trackTags"
                  value="true"
                  checked={form.tmdsTagsPlaced}
                  onChange={this.confirmChanged}
                />
              </div>
            );

            if (
              form.type === "A" &&
              form.reasonDescription.startsWith("COMPACTION")
            ) {
              form.sendToTss = true;
              createInTss = (
                <div>COMPACTION restriction will be created in TSS</div>
              );
            }
            else if (form.type === "A" && Number(form.freightSpeed) === Number(window.gritConfig.keyTrainSpd)) {
              //If the freight speed is set to the key train speed, don't show the question
              form.sendToTss = true;
              createInTss = (
                  <div>Restriction will be created in TSS</div>
              );
            }
            else {
              createInTss = (
                  <div>
                    Restriction will be created in TSS
                  </div>
              );
            }
          } else {
            if (
              this.state.checkComments ||
              this.props.form.comments.length === 0 ||
              this.props.form.id === "" ||
              userRoles.indexOf(Constants.Roles.FIELD_USER) === 0
            ) {
              disableSubmit = false;
            } else {
              disableSubmit = true;
            }
          }
        }
      } else if (form.status === Constants.RestrictionStatuses.ISSUED) {
        if (userRoles.indexOf(Constants.Roles.FIELD_SLODT) > -1) {
          //slodt
          sloDt = (
            <div>
              <label>Optional slow order change comment:</label>
              <input
                type="text"
                style={{ width: "225px" }}
                value={this.state.sloDtComment}
                id="sloDtComment"
                onChange={this.onChangeToUpper}
                onBlur={this.sloDtOnBlur}
                name="sloDtComment"
                maxLength="160"
              />
            </div>
          );
          disableSubmit = false;
        } else if (userRoles.indexOf(Constants.Roles.DISPATCHER) > -1) {
          //dispatcher modifying a restriction (void & reissue)
          if (
            this.state.checkComments ||
            this.props.form.comments.length === 0 ||
            this.props.form.id === "" ||
            userRoles.indexOf(Constants.Roles.FIELD_USER) === 0
          ) {
            disableSubmit = false;
          } else {
            disableSubmit = true;
          }
        }
      }

      component = (
        <div>
          <div>
            Subdivision: <span className="bold">{form.subdivision}</span>
          </div>
          <div>
            From MP:{" "}
            <span className="bold">
              {form.workStartMp} {form.workStartMpSuffix}
            </span>
          </div>
          <div>
            To MP:{" "}
            <span className="bold">
              {form.workEndMp} {form.workEndMpSuffix}
            </span>
          </div>

          <div>
            Passenger speed: <span className="bold">{form.passengerSpeed}</span>
          </div>
          <div>
            Freight speed: <span className="bold">{form.freightSpeed}</span>
          </div>

          <div>
            Estimated Removal Date:{" "}
            <span className="bold">
              {workEndDateTime.format("ddd MM/DD/YY")}
            </span>
          </div>

          <div>
            Short Flag:{" "}
            <span className="bold">
              {form.shortFlagOneMp} {form.shortFlagOneMpSuffix}
            </span>
          </div>
          <div>
            Short Flag:{" "}
            <span className="bold">
              {form.shortFlagTwoMp} {form.shortFlagTwoMpSuffix}
            </span>
          </div>
          <div>
            No Flags:{" "}
            <span className="bold">
              {form.shortFlagsNotDisplayed ? "Y" : ""}
            </span>
          </div>
          <div>
            Effective DateTime:{" "}
            <span className="bold">{workStartDateTime}</span>
          </div>

          <div>
            Reason: <span className="bold">{form.reasonDescription}</span>
          </div>
          <div>
            Phone Number: <span className="bold">{form.phoneNumber}</span>
          </div>

          <div>
            Requested by: <span className="bold">{form.authorizedBy}</span>
          </div>
          <div>
            Tracks:{" "}
            <span className="bold">
              {form.tracks
                .map(function (track) {
                  return track.name;
                })
                .join(", ")}
            </span>
          </div>

          <div>
            Comments:
            <span className="bold">{comments}</span>
          </div>
          <div>
            Bordering Flags: <span className="bold">{flags}</span>
          </div>
          {commentReview}
          <br />
          {sloDt}
          {confirmTagsPlaced}
          {createInTss}
        </div>
      );
    } else if (form.type === TYPES.B) {
      var commentReview = (
        <div className={this.state.commentsCheckclass}>
          <span>I have reviewed the comments </span>
          <input
            type="checkbox"
            className={this.state.commentsCheckclass}
            disabled={this.state.commentsDisable}
            checked={this.state.checkComments}
            id="commentsRead"
            name="commentsRead"
            value="active"
            onChange={this.commentsOnChange}
          />
        </div>
      );
      startDateTime = moment(
        form.workStartDate + " " + form.workStartTime,
        "MMDDYY HHmm"
      );
      var endDateTime = moment(
        form.workEndDate + " " + form.workEndTime,
        "MMDDYY HHmm"
      );
      workStartDateTime =
        startDateTime.format("ddd HH:mm") +
        "{tz} ".replace("{tz}", form.timezone) +
        startDateTime.format("MM/DD/YY");
      var workEndDatetime =
        endDateTime.format("ddd HH:mm") +
        "{tz} ".replace("{tz}", form.timezone) +
        endDateTime.format("MM/DD/YY");
      var startDateTimeTZ = moment.tz(
        form.workStartDate + form.workStartTime,
        "MMDDYYHHmm",
        Constants.Timezones[form.timezone]
      );

      var hideSuperName = !moment()
        .tz(Constants.Timezones[form.timezone])
        .add(userRoles.indexOf(Constants.Roles.FIELD_USER) === 0 ? sessionStorage.getItem("formBRequestThreshold") : 720, "minutes")
        .isAfter(startDateTimeTZ);

      if (
        this.state.checkComments ||
        this.props.form.comments.length === 0 ||
        this.props.form.id === "" ||
        userRoles.indexOf(Constants.Roles.FIELD_USER) === 0
      ) {
        disableSubmit = hideSuperName ? false : !this.state.superName;
      } else {
        disableSubmit = true;
      }

      component = (
        <div>
          <div>
            Subdivision: <span className="bold">{form.subdivision}</span>
          </div>
          <div>
            From MP:{" "}
            <span className="bold">
              {form.workStartMp} {form.workStartMpSuffix}
            </span>
          </div>
          <div>
            To MP:{" "}
            <span className="bold">
              {form.workEndMp} {form.workEndMpSuffix}
            </span>
          </div>
          <div>
            From DateTime:<span className="bold">{workStartDateTime}</span>
          </div>
          <div>
            To DateTime:<span className="bold">{workEndDatetime}</span>
          </div>
          <div>
            Short Flag:{" "}
            <span className="bold">
              {form.shortFlagOneMp} {form.shortFlagOneMpSuffix}
            </span>
          </div>
          <div>
            Short Flag:{" "}
            <span className="bold">
              {form.shortFlagTwoMp} {form.shortFlagTwoMpSuffix}
            </span>
          </div>
          <div>
            Foreman: <span className="bold">{form.foremanName}</span>
          </div>
          <div>
            Gang: <span className="bold">{form.gang}</span>
          </div>
          <div>
            Phone Number: <span className="bold">{form.phoneNumber}</span>
          </div>
          <div>
            Radio Channel: <span className="bold">{form.radioChannel}</span>
          </div>
          <div>
            Reason: <span className="bold">{form.reasonDescription}</span>
          </div>
          <div>
            Restriction will impede traffic:{" "}
            <span className="bold">{form.impedesTraffic}</span>
          </div>
          <div>
            Tracks:{" "}
            <span className="bold">
              {form.tracks
                .map(function (track) {
                  return track.name;
                })
                .join(", ")}
            </span>
          </div>
          <div>
            Comments:<span className="bold">{comments}</span>
          </div>
          <div>
            Bordering Flags: <span className="bold">{flags}</span>
          </div>
          <span hidden={hideSuperName}>Supervisor Approval:</span>
          <input
            type="text"
            hidden={hideSuperName}
            style={{ width: "150px" }}
            onChange={this.superOnChange}
            onBlur={this.SuperOnBlur}
            value={this.state.superName}
            id="supervisorName"
            name="Supervisor Name"
            maxLength="24"
          />
          <hr />
          {commentReview}
        </div>
      );
    } else if (form.type === TYPES.C) {
      let estimatedRemovalDate = moment(form.estimatedRemovalDate, "MMDDYYYY");
      let restrictionText = "";
      let fromText = "";
      let toText = "";
      let formCDt = "";
      disableSubmit = false;
      let subs = "";

      if (userRoles.indexOf(Constants.Roles.FIELD_SLODT) > -1) {
        //formCDT
        formCDt = (
          <div>
            <label>Optional Form C Date Change Comment:</label>
            <input
              type="text"
              style={{ width: "225px" }}
              value={this.state.formCDTComment}
              id="formCDTComment"
              onChange={this.onChangeToUpper}
              onBlur={this.formCDtOnBlur}
              name="formCDTComment"
              maxLength="160"
            />
          </div>
        );
      }

      if (form.comments) {
        let sortedText = form.comments.sort(function (c1, c2) {
          return sortFunction(c1, c2);
        });

        let text = sortedText.map(function (line) {
          return line.comment;
        });

        restrictionText = text.join("\n");
      }

      if (form.subdivisions && form.subdivisions.length > 1) {
        modalTitle = (
          <Modal.Title>
            Confirm:{" "}
            {this.props.question.charAt(0).toUpperCase() +
              this.props.question.slice(1)}{" "}
            on multiple subdivisions?
          </Modal.Title>
        );
        const popover = (
          <Popover id="popover-subs">
            <table>
              <tbody>
                {form.subdivisions.map((val, i) => (
                  <tr key={i}>
                    <td>{val}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Popover>
        );

        subs = (
          <OverlayTrigger placement="right" overlay={popover}>
            <span className="glyphicon glyphicon-question-sign" />
          </OverlayTrigger>
        );
      } else if (form.subdivision !== "ALL") {
        //Single Sub
        if (form.workStartMp !== "") {
          fromText = (
            <div>
              From MP:{" "}
              <span className="bold">
                {form.workStartMp} {form.workStartMpSuffix}
              </span>
            </div>
          );
          toText = (
            <div>
              To MP:{" "}
              <span className="bold">
                {form.workEndMp} {form.workEndMpSuffix}
              </span>
            </div>
          );
        } else {
          fromText = (
            <div>
              From Location: <span className="bold">{form.fromLocation}</span>
            </div>
          );
          toText = (
            <div>
              To Location: <span className="bold">{form.toLocation}</span>
            </div>
          );
        }
      } else {
        //All subdivisions
        modalTitle = (
          <Modal.Title>
            Confirm:{" "}
            {this.props.question.charAt(0).toUpperCase() +
              this.props.question.slice(1)}{" "}
            on ALL subdivisions?
          </Modal.Title>
        );
      }

      component = (
        <div>
          <div>
            Subdivision:{" "}
            <span className="bold">
              {form.subdivision} {subs}
            </span>
          </div>
          {fromText}
          {toText}
          <div>
            Authorized By: <span className="bold">{form.authorizedBy}</span>
          </div>
          <div>
            Estimated Removal Date:{" "}
            <span className="bold">
              {estimatedRemovalDate.format("ddd MM/DD/YY")}
            </span>
          </div>
          <div>Text: </div>
          <div>
            <textarea
              id="formCText"
              rows={20}
              cols={62}
              value={restrictionText}
              disabled={true}
            />
          </div>
          {formCDt}
        </div>
      );
    } else if (form.type === TYPES.TCM) {
      let estimatedRemovalDate = moment(form.estimatedRemovalDate, "MMDDYYYY");
      let restrictionText = "";
      let fromText = "";
      let toText = "";
      let formTCMDt = "";
      disableSubmit = false;

      if (userRoles.indexOf(Constants.Roles.FIELD_SLODT) > -1) {
        //TCMDT
        formTCMDt = (
          <div>
            <label>Optional TCM Date Change Comment:</label>
            <input
              type="text"
              style={{ width: "225px" }}
              value={this.state.formTCMDTChangeComment}
              id="formTCMDTComment"
              onChange={this.onChangeToUpper}
              onBlur={this.formTCMDtOnBlur}
              name="formTCMDTComment"
              maxLength="160"
            />
          </div>
        );
      }

      if (form.comments) {
        let sortedText = form.comments.sort(function (c1, c2) {
          return sortFunction(c1, c2);
        });

        let text = sortedText.map(function (line) {
          return line.comment;
        });

        restrictionText = text.join("\n");
      }

      if (form.subdivisions && form.subdivisions.length > 1) {
        modalTitle = (
          <Modal.Title>
            Confirm:{" "}
            {this.props.question.charAt(0).toUpperCase() +
              this.props.question.slice(1)}{" "}
            on multiple subdivisions?
          </Modal.Title>
        );
      } else if (form.subdivision !== "ALL") {
        //Single Sub
        if (form.workStartMp !== "") {
          fromText = (
            <div>
              From MP:{" "}
              <span className="bold">
                {form.workStartMp} {form.workStartMpSuffix}
              </span>
            </div>
          );
          toText = (
            <div>
              To MP:{" "}
              <span className="bold">
                {form.workEndMp} {form.workEndMpSuffix}
              </span>
            </div>
          );
        } else {
          fromText = (
            <div>
              From Location: <span className="bold">{form.fromLocation}</span>
            </div>
          );
          toText = (
            <div>
              To Location: <span className="bold">{form.toLocation}</span>
            </div>
          );
        }
      } else {
        //All subdivisions
        modalTitle = (
          <Modal.Title>
            Confirm:{" "}
            {this.props.question.charAt(0).toUpperCase() +
              this.props.question.slice(1)}{" "}
            on ALL subdivisions?
          </Modal.Title>
        );
      }

      component = (
        <div>
          <div>
            Subdivision: <span className="bold">{form.subdivision}</span>
          </div>
          {fromText}
          {toText}
          <div>
            Authorized By: <span className="bold">{form.authorizedBy}</span>
          </div>
          <div>
            Estimated Removal Date:{" "}
            <span className="bold">
              {form.permanentIndicator === "Y"
                ? "Permanent"
                : estimatedRemovalDate.format("ddd MM/DD/YY")}
            </span>
          </div>
          <div>
            Print Desk Copy:{" "}
            <span className="bold">
              {form.printIndicator === "Y" ? "Yes" : "No"}
            </span>{" "}
          </div>
          <div>
            Condition Permanent:{" "}
            <span className="bold">
              {form.permanentIndicator === "Y" ? "Yes" : "No"}
            </span>
          </div>
          <div>Text: </div>
          <div>
            <textarea
              id="TCMText"
              rows={20}
              cols={62}
              value={restrictionText}
              disabled={true}
            />
          </div>
          {formTCMDt}
        </div>
      );
    }
    return (
      <div>
        <Button
          id="submitButton"
          bsStyle="primary"
          disabled={this.props.disabled}
          onClick={this.open}
        >
          {buttonText}
        </Button>
        <Modal
          bsSize="large"
          backdrop="static"
          dialogClassName="confirmationModal"
          onHide={this.close}
          show={this.state.showModal}
        >
          <Modal.Header closeButton>{modalTitle}</Modal.Header>

          <div className="modal-body">{component}</div>
          <div className="modal-footer">
            <span className="deetsQuestionSpan">
              Are you sure you want to {this.props.question}?
            </span>
            <Button
              id="confirmSubmitButton"
              bsStyle="danger"
              disabled={disableSubmit}
              onClick={this.submit}
            >
              {buttonText}
            </Button>
            <Button id="cancelConfirmButton" onClick={this.cancel}>
              Cancel
            </Button>
          </div>
        </Modal>
      </div>
    );
  },
});

function sortFunction(c1, c2) {
  if (c1.lineNumber < c2.lineNumber) {
    return -1;
  }
  if (c1.lineNumber > c2.lineNumber) {
    return 1;
  }
  // a must be equal to b
  return 0;
}
